import { render, staticRenderFns } from "./ModalParecerDescritivo.vue?vue&type=template&id=7d1dc02d&"
import script from "./ModalParecerDescritivo.vue?vue&type=script&lang=js&"
export * from "./ModalParecerDescritivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports